import { render } from "./FormPts.vue?vue&type=template&id=e8baff10&scoped=true"
import script from "./FormPts.vue?vue&type=script&lang=js"
export * from "./FormPts.vue?vue&type=script&lang=js"

import "./FormPts.vue?vue&type=style&index=0&id=e8baff10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8baff10"]])

export default __exports__